import { Toaster, type UiLabels, UiProvider } from '@bloom/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode, useState } from 'react';
import { shouldRetry } from '../lib/api/client';
import { SessionProvider } from '../lib/session';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: shouldRetry, staleTime: 30_000, refetchOnWindowFocus: false },
      mutations: { retry: false },
    },
  });
}

/** The few words the design system needs, in Egyptian Arabic. */
const LABELS: UiLabels = {
  close: 'اقفل',
  loading: 'بنحمّل...',
  previousPage: 'السابق',
  nextPage: 'التالي',
  pageSummary: (page, totalPages, total) => `صفحة ${page} من ${totalPages} (${total})`,
  sortAscending: 'ترتيب تصاعدي',
  sortDescending: 'ترتيب تنازلي',
  retry: 'جرّب تاني',
  openNavigation: 'افتح القايمة',
  collapseNavigation: 'صغّر القايمة',
  expandNavigation: 'كبّر القايمة',
  cancel: 'إلغاء',
};

export function AppProviders(props: { children: ReactNode; queryClient?: QueryClient }) {
  const [client] = useState(() => props.queryClient ?? createQueryClient());
  return (
    <QueryClientProvider client={client}>
      <SessionProvider>
        <UiProvider dir="rtl" labels={LABELS}>
          <Toaster>{props.children}</Toaster>
        </UiProvider>
      </SessionProvider>
    </QueryClientProvider>
  );
}
